import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import OrderManagementTable from "../../components/OrderManagement/OrderManagementTable";
import OrderManagementV2 from "../../components/OrderManagement/OrderManagementV2";
// import PaymentTable from "../../components/PaymentComp/Paymenttable";
import PaymentManagement from "../../components/PaymentComp/PaymentManagement";





const Payments = () => {
    return (
        <>

            <MasterLayout>

                <Breadcrumb title="Payment Detail" />
                {/* <OrderManagementTable/> */}
                {/* <OrderManagementV2/> */}
                <PaymentManagement />







            </MasterLayout>
        </>
    );
};

export default Payments;
